var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v("Configure " + _vm._s(_vm.template.name) + " Table"),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _vm._l(_vm.template.actions, function (action) {
            return [
              action.type === "filter"
                ? _c(
                    "rb-input",
                    { key: "f" + action.id },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(action.label)),
                      ]),
                      _c(
                        "rb-select",
                        {
                          staticClass: "simple",
                          model: {
                            value: _vm.filters[action.id],
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, action.id, $$v)
                            },
                            expression: "filters[action.id]",
                          },
                        },
                        _vm._l(action.options, function (option) {
                          return _c(
                            "rb-option",
                            {
                              key: option.label,
                              attrs: { value: option.filter },
                            },
                            [_vm._v(" " + _vm._s(option.label) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : action.type === "toggle"
                ? _c(
                    "rb-input",
                    {
                      key: "t" + action.id,
                      attrs: { error: _vm.$showError(action.id) },
                    },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(action.label)),
                      ]),
                      _c(
                        "rb-checkboxes",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          attrs: {
                            field: _vm.fields[action.id],
                            name: action.id,
                            "data-vv-as": action.label,
                          },
                          model: {
                            value: _vm.filters[action.id],
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, action.id, $$v)
                            },
                            expression: "filters[action.id]",
                          },
                        },
                        _vm._l(action.options, function (option) {
                          return _c(
                            "rb-checkbox",
                            { key: option.id, attrs: { value: option.id } },
                            [_vm._v(" " + _vm._s(option.label) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }